var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWebIconsVision(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".ab4a3ecc-4a17-458a-81ee-dc919de18507{fill:none;stroke:#000;stroke-miterlimit:10;stroke-width:8px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a0252696-01a0-4e02-8101-fcbdd2113332",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 189.92,
    cy: 47.2,
    r: 23.91
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.5,78.38l19.62,54.91a4.35,4.35,0,0,0,5.69,2.58h0a4.34,4.34,0,0,0,2.49-5.53L205.4,75.6l4.48-3,81.56-29.92A10.13,10.13,0,0,1,304.55,49l.22.68a10.12,10.12,0,0,1-6.28,12.73l-66.4,23.2,41.85,111-22.42,13.66-12.6-35.44L234.86,177l13.24,35.45-22,13.24L208,176.38s.64,5.34-5.77,6.2-9.6-6.62-9.6-6.62l-26.31-73.77a13.06,13.06,0,0,1,7.47-16.52l16.17-6.44Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "23.05 328.2 166.75 257.31 165.52 242.15 160.13 238.73 23.05 328.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45,352.11l128.11-63a20.06,20.06,0,0,1-6.4-15.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.46,375.81,221,300l-12.31-14.09s-7.76,6.83-15.87,8.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ab4a3ecc-4a17-458a-81ee-dc919de18507",
    d: "M184.9,178.62l-51.14,10.06a2.71,2.71,0,0,0-1.13,4.81l49.71,38.3,3.9,42a2,2,0,0,0,2.82,1.59l24.77-11.9,48.24,55.38a2.57,2.57,0,0,0,4.1-.31l107.27-170a2.23,2.23,0,0,0-2.26-3.38l-100.12,17.4"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ab4a3ecc-4a17-458a-81ee-dc919de18507",
    points: "279.38 186.63 365.22 148.2 368.74 152.04 205.08 251.33 191.66 274.15"
  }), /*#__PURE__*/React.createElement("line", {
    className: "ab4a3ecc-4a17-458a-81ee-dc919de18507",
    x1: 213.83,
    y1: 217.06,
    x2: 182.34,
    y2: 231.79
  }), /*#__PURE__*/React.createElement("line", {
    className: "ab4a3ecc-4a17-458a-81ee-dc919de18507",
    x1: 204.44,
    y1: 254.59,
    x2: 212.9,
    y2: 263.95
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebIconsVision);
export default __webpack_public_path__ + "static/media/web-icons_vision.3cdc462bcfbdb8005a1a08fe6304662e.svg";
export { ForwardRef as ReactComponent };